module.exports = __webpack_public_path__ + "img/services_rubber_installation.a9955243.jpg";